var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"root"},[_c('div',{staticClass:"result"},[_vm._v(" "+_vm._s(_vm.$ctc("total",_vm.total, {amount: _vm.total}))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }